import styles from './HostServiceMarker.module.css'
import { AdvancedMarker } from '@vis.gl/react-google-maps'
import FavoriteIcon from '@mui/icons-material/Favorite'
import classNames from 'classnames'
import { useState } from 'react'
import { UnderObservationIcon } from 'shared/icons'

interface HostServiceMarkerProps {
    hostService: any
    selected?: boolean
    index: number
    onClick?: (hostService: any) => void
}

export const HostServiceMarker = (props: HostServiceMarkerProps) => {
    const {
        hostService,
        onClick,
        selected = true,
        index
    } = props
    const [showDetails, setShowDetails] = useState<boolean>(false)

    const customPinRootClasses = classNames(styles.HostServiceMarker_Root, {
        [styles.HostServiceMarker__Root__Selected]: selected
    })

    const handleAdvancedMarkerClick = () => {
        setShowDetails(true)
        onClick?.(hostService)
    }

    let text = `X` 
    if (hostService?.priceTotal !== undefined && hostService?.priceTotal?.list?.length > 0){
        text = `$${hostService?.priceTotal.list[0].value}`
    }


    const renderCustomPin = () => {
        return (
            <div className={customPinRootClasses}>
                <div className={styles.HostServiceMarkerPin_DetailsContainer}>
                    
                </div>

                <div className={styles.HostServiceMarker__PinContainer}>
                    <div className={styles.HostServiceMarker__Body}>
                        <div className={styles.HostServiceMarker__PinCaption}>{text}</div>
                        <div className={styles.HostServiceMarker_PropSpyIconContainer}>
                            {
                                hostService.propSpy && (
                                    <UnderObservationIcon
                                        className={styles.HostServiceMarker_PropSpyIcon}
                                        htmlColor={'rgba(255, 255, 255, 1)'}
                                        fontSize={'inherit'}
                                    />
                                )
                            }
                        </div>
                    </div>
                    <div className={styles.HostServiceMarker_Position}>
                        Position: {index}
                    </div>
                </div>
            </div>              
        )
    }


    return (
        <AdvancedMarker
            zIndex={selected === true ? 1: 0 }
            position={{
                lat: hostService?.latitude,
                lng: hostService?.longitude
            }}
            title={''}
            onClick={handleAdvancedMarkerClick}
        >
            {renderCustomPin()}
        </AdvancedMarker>
    )
}